import { z } from "zod";

/**
 * TagNodeSchema - Content Schema for Tag Entity Node
 *
 * Tag nodes represent hashtag labels for categorization.
 *
 * Field naming convention:
 * - tagId: Tag UUID (references memo_tag.id) - REQUIRED
 *
 * Note: displayName and colorToken are NOT stored in TagNode.
 * They are looked up from the TagService using tagId (SSOT pattern).
 */
export const TagNodeSchema = z.object({
  // Protocol metadata
  type: z.literal("tag"),
  version: z.literal(1),
  key: z.string(),

  // Business data - ONLY tagId is stored
  tagId: z.string().uuid(), // Required - references memo_tag.id
});

export type TagNode = z.infer<typeof TagNodeSchema>;
